<template>
    <div id="menu-bar" class="w-full bg-grey-lightest shadow-lg flex flex-row justify-between items-center">
        <div class="flex-1">
            <router-link to="/Home">
                <img class="cursor-pointer ml-1" alt="Ed Budding Installatietechniek" src="/img/logo.png">
            </router-link>
        </div>
        <div class="flex-1 mr-1">
            <Push right width="150">
                <div class="w-full h-full flex flex-col justify-start items-start">
                    <img id="image" class="mb-10 mt-2" alt="ebudding" src="/favicon.ico"/>
                    <router-link v-for="page in pages" class="text-grey-light hover:text-grey-dark my-2"
                                 :to="page.route.to">
                        {{page.route.name}}
                    </router-link>
                </div>
            </Push>
        </div>
    </div>
</template>

<script>
    import {Push} from 'vue-burger-menu'

    export default {
        name: "MenuBarResponsive",
        props: ['pages'],
        components: {
            Push
        }
    }
</script>

<style scoped>
    @import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro');

    #menu-bar {
        width: 100%;
        height: 3rem;
        border-bottom: 1px solid #22292f;
    }

    img {
        display: block;
        max-width: 125px;
        max-height: 60px;
        width: auto;
        height: auto;
    }

    #image {
        display: block;
        max-width: 80px;
        max-height: 70px;
        width: auto;
        height: auto;
    }
</style>
